export enum AnalyticsEventType {
  Error = 'ValidationError',
  Interaction = 'AngMenuItemClick',
  Navigation = 'SSO_registration_PV',
  SignInError = 'loginfailed',
  SignInSuccess = 'successful_login'
}
